// TODO @cleanup this should be merged with InitIFrameApp
import {handleFirstJSError} from "../blink-sdk/utils/AnalyticsClient";

// TODO @branch still not the optimal place
window.onerror = handleFirstJSError;

// TODO any file that doesn't import UI will crash when being rendered since UI.createElement is not valid
//  Identify all instances and cleanup
import {UI} from "../stem-core/src/ui/UIBase.js";

window.UI = UI;

export * from "./State";
export * from "./InitIFrameApp";
